var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68893 17.3779C3.89828 17.3779 0 13.4796 0 8.68893C0 3.89828 3.89828 0 8.68893 0C13.4796 0 17.3779 3.89828 17.3779 8.68893C17.3779 13.4796 13.4796 17.3779 8.68893 17.3779Z",
    fill: "#FF8600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6326 13.6209C11.5351 13.6209 11.4458 13.5719 11.3547 13.5368L10.8688 13.3495C9.46642 12.8089 7.91289 12.8103 6.51152 13.3536L5.90265 13.5896C5.77741 13.6522 5.62085 13.6209 5.51126 13.5426C5.40167 13.4643 5.33905 13.3391 5.3547 13.1982C5.46541 11.2758 4.84169 9.37668 3.61692 7.89089C3.53864 7.7813 3.50733 7.6404 3.55429 7.4995C3.60126 7.37425 3.6952 7.26466 3.8361 7.23335C5.69818 6.75022 7.32134 5.56451 8.3606 3.94565C8.42322 3.83606 8.56413 3.77344 8.68937 3.77344C8.83027 3.77344 8.95552 3.83606 9.0338 3.94565C10.0731 5.56451 11.6962 6.75022 13.5583 7.23335C13.6835 7.26466 13.7931 7.37425 13.8401 7.4995C13.8871 7.6404 13.8558 7.7813 13.7618 7.89089C12.5435 9.38106 11.929 11.2766 12.0397 13.1982C12.0397 13.2486 12.0317 13.297 12.0164 13.3419C11.9619 13.502 11.8017 13.6209 11.6326 13.6209Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.536364ffa82a3344bfb9aef941c0af99.svg";
export { ForwardRef as ReactComponent };